import React from 'react'
import DateHumanizeHelper from '../../../../../helpers/DateHumanizeHelper'

const LastActiveCell = ({ text, record }) => text

const lastActiveCellRenderer = (text, record) => <LastActiveCell text={DateHumanizeHelper(text)} record={record} />

export default lastActiveCellRenderer
